import React, { useContext, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { LanguageContext } from '@lib/i18n/LanguageProvider';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';

type LayoutContextType = {
  setLayoutContext: (title: string) => void;
  setLayoutHeaderImage: (url: string) => void;
  setPageTitle: (pageTitle: string) => void;
  setPageSummary: (pageSumamry: string) => void;
  setVideoHelpUrl: (helpUrl: string) => void;
  setShowHeader: (showHeader: boolean) => void;
  setShowSidebar: (showSidebar: boolean) => void;
  setShowSummaryOnMobile: (showSummaryOnMobile: boolean) => void;
};

const PageNotFound: React.FC = () => {
  const {
    setLayoutContext,
    setLayoutHeaderImage,
    setPageTitle,
    setPageSummary,
    setVideoHelpUrl,
    setShowHeader,
    setShowSidebar,
    setShowSummaryOnMobile
  } = useOutletContext<LayoutContextType>();

  const { translations = {}, lang = 'tr-TR' } = useContext(LanguageContext) || {};

  const title = translations['404_title'];
  const summary = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid assumenda dignissimos saepe.";
  const helpUrl = "";

  useEffect(() => {
    // Layout'a gönderilecekler, başlık, açıklama, yardım video linki
    //setLayoutContext(title);
    setPageTitle(title);
    setPageSummary(summary);
    setVideoHelpUrl(helpUrl);
    setShowHeader(false);
    setShowSidebar(false);
    setShowSummaryOnMobile(false);

    // Header görseli
    const headerImage = require('@images/header/top-header.png');
    const defaultHeaderImage = require('@images/header/top-header.png');
    setLayoutHeaderImage(headerImage);

    return () => setLayoutHeaderImage(defaultHeaderImage);
  }, [title, summary, helpUrl, setLayoutContext, setPageTitle, setPageSummary, setLayoutHeaderImage, setVideoHelpUrl, setShowHeader, setShowSidebar, setShowSummaryOnMobile]);

  return (
    <div className="content-inner container-fluid pb-0">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h1>{translations['404_title']}</h1>
        <p>{translations['404_text']}</p>
      </div>
    </div>

  );
};

export default PageNotFound;
